'use strict';

$(document).ready(function() {
    function setHeightMenuMob() {
        if($(window).outerWidth()<991) {
            var heightHeader = $('header').height();
            $('.main-menu').css('margin-top', heightHeader + 'px');
            $('.page').css('padding-top', heightHeader + 'px');
        }
    }
    setHeightMenuMob();
    $('.header-banner .close').on('click', function () {
        setHeightMenuMob();
    });
});
